
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 55.563 66.146","height":"250","width":"210"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(.18899 0 0 .18899 -.506 8.89)"}},[_c('path',{attrs:{"d":"M49.679 78.619a100 100 0 010 0 100 100 0 01100-100 100 100 0 01100 100","fill":"none","stroke":"#f5f5f5","stroke-width":"40","stroke-linecap":"round"}}),_c('path',{attrs:{"fill":"#f5f5f5","d":"M29.679 79.461h40v66.667h-40zM229.679 79.461h40v66.667h-40z"}}),_c('rect',{attrs:{"width":"280","height":"180","x":"9.679","y":"117.3","rx":"20","ry":"20","fill":"#f5f5f5"}})])])
          )
        }
      }
    